module.exports = __webpack_public_path__ + "fonts/display-semibold.a4679e70.woff2";